import appApi, { type AxiosResponse } from "@/app/api";
import { TCloudAPIResponse } from "@/types/app";
import { CHECKOUT_SERVICE_BASE_URL } from "../constants.checkout";
import { TCheckoutData } from "../types.checkout";

const APIURL = `${CHECKOUT_SERVICE_BASE_URL}/pricing/metadata`;

interface Option {
  appLang: string;
  referrer?: string | null;
  token?: string;
  promoCode?: string | null;
}

type TResponse = TCloudAPIResponse<TCheckoutData | null>;

export const getCheckoutData = async (
  option: Option,
): Promise<TCheckoutData | null> => {
  const { appLang = "en", referrer = null, token, promoCode } = option || {};

  const headers = {
    lang: appLang || "en",
    ...(token ? { Authorization: "Bearer " + token } : {}),
  };

  try {
    const response: AxiosResponse<TResponse> = await appApi.get(APIURL, {
      headers,
      params: {
        referrer: referrer || null,
        ...(promoCode ? { promo_code: promoCode } : {}),
      },
    });
    const resData = response.data;
    return resData.data;
  } catch (error) {
    console.error("Error fetching checkout data:", error);
    return null;
  }
};
